import React from 'utils/react';
import { withRouter } from 'react-router-dom';

import Container from 'components/Menu';
import { urls } from 'config';

import MenuButton from './MenuButton';
import MenuLink from './MenuLink';
import withTranslation from 'utils/react/withTranslation';

const Menu = (props) => {
  const { dataset, setEditableDataset, deleteDataset, history, t } = props;
  const id = dataset.get('id');

  const onDelete = () => {
    deleteDataset(id);
    history.push('/datasets');
  };

  return (
    <Container>
      <MenuLink href={urls.datasetCsv(id)}>
        {t('c.Header.Menu.DownloadCSV')}
      </MenuLink>
      <MenuButton onClick={() => setEditableDataset(dataset)}>
        {t('c.Header.Menu.Edit')}
      </MenuButton>
      <MenuButton onClick={onDelete}>{t('c.Header.Menu.Delete')}</MenuButton>
    </Container>
  );
};

export default withRouter(withTranslation()(Menu));
